import { observer } from "mobx-react-lite"
import { useStore } from "../../stores/root-store-context";
import { Button, Form, Input, Modal, Select, Spin, message } from "antd";
import { useTranslation } from "react-i18next";
import { DocumentEditor } from "../Projects/ProjectPage";
import { useEffect, useState } from "react";
import { Roles } from "../../enums/Roles";

export type InviteUser = {
    email: string,
    role: keyof typeof Roles,
    chiefId: string,
}
export const AddBulkEmail = observer((props: { isModalOpen: boolean, hideModal: () => void}) => {
    const { isModalOpen, hideModal } = props;
    const { employeesStore, applicationStore } = useStore();
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const activeUsers = employeesStore.users.filter(u => u.isActive);
    const [selectedUsers, setSelectedUsers] = useState<string[]>();
    const [isLoading, setIsLoading] = useState(false);

    const allSelected = selectedUsers?.length === activeUsers.length;
    const selectAllLabel = allSelected ? t("DeselectAll") : t("SelectAll");

    const handleSubmit = async (values: any) => {
        setIsLoading(true);

        console.log("companyId", applicationStore.user?.companyId);
        console.log("user", applicationStore.user);

        const isSendEmail = await applicationStore.sendBulkEmail({
            companyId: applicationStore.user?.companyId,
            toEmails: values.emails,
            subject: values.subject,
            message: values.message,
        });

        if (!isSendEmail) {
            message.error(t("bulkEmail.latterSendError"));
            setIsLoading(false);
            return;
        }

        message.success(t("bulkEmail.latterSendSeccses"));

        form.resetFields();
        setSelectedUsers([]);
        setIsLoading(false);
        hideModal();
    };

    const handleFailedSubmit = (errorInfo: any) => {
        message.error(t("bulkEmail.latterSendError"));
        console.error("Failed:", errorInfo);
    };

    return (
        <Modal title={t("bulkEmail.sendBulkEmail")} open={isModalOpen} footer={null} onCancel={hideModal} width={900}>
            <Spin spinning={isLoading} size="large" >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                    onFinishFailed={handleFailedSubmit}
                    style={{ maxWidth: 900, margin: "0 auto" }}
                >
                    <Form.Item
                        label={t("Users")}
                        name="emails"
                        style={{ height: "auto", overflow: "hidden" }}
                        rules={[
                            { required: true, message: t("bulkEmail.pleaseSelectUsers") },
                        ]}
                    >
                        <Select
                            mode="multiple"
                            placeholder={t("bulkEmail.selectUsers")}
                            style={{ width: '100%' }}
                            value={selectedUsers}
                            onChange={(value) => {
                                if (value.includes("all")) {
                                    const allEmails = activeUsers.map((user) => user.email);
                                    const isAllSelected = selectedUsers?.length === allEmails.length;

                                    if (isAllSelected) {
                                        setSelectedUsers([]);
                                        form.setFieldValue("emails", []);
                                    } else {
                                        setSelectedUsers(allEmails);
                                        form.setFieldValue("emails", allEmails);
                                    }
                                } else {
                                    setSelectedUsers(value);
                                    form.setFieldValue("emails", value);
                                }
                            }}

                            filterOption={(input, option) => {
                                const user = activeUsers.find(u => u.email === option?.value);
                                if (!user) return false;

                                const fullName = `${user.firstName} ${user.lastName}`.toLowerCase();
                                const email = user.email.toLowerCase();
                                const search = input.toLowerCase();

                                return fullName.includes(search) || email.includes(search);
                            }}
                            optionLabelProp="label"
                        >
                            <Select.Option key="all" value="all" label={t("SelectAll")}>
                                <strong>{selectAllLabel}</strong>
                            </Select.Option>

                            {activeUsers.map((user) => (
                                <Select.Option
                                    key={user.email}
                                    value={user.email}
                                    label={`${user.firstName} ${user.lastName}`}
                                >
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <img
                                            src={
                                                user.photoId
                                                    ? `${applicationStore?.siteConfig?.baseCloudinary}/image/upload/w_300/${user.photoId}`
                                                    : `https://res.cloudinary.com/dnl3x07wo/image/upload/w_300/z03w7hlsy8hcoic9dlcn`
                                            }
                                            alt="avatar"
                                            style={{
                                                width: "30px",
                                                height: "30px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                            }}
                                        />
                                        <div>
                                            <div style={{ fontSize: "12px", color: "#666" }}>
                                                {user.firstName} {user.lastName}
                                            </div>
                                            <span>{user.email}</span>
                                        </div>
                                    </div>
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={t("bulkEmail.topic")}
                        name="subject"
                        rules={[{ required: true, message: t("bulkEmail.plaeseWriteTopic") }]}
                    >
                        <Input placeholder="Тема листа" />
                    </Form.Item>
                    <Form.Item
                        label={t("bulkEmail.laterText")}
                        name="message"
                        rules={[{ required: true, message: t("bulkEmail.pleaseWriteLaterText") }]}
                        style={{ height: "auto", overflow: "hidden" }}

                    >
                        <DocumentEditor
                            initialContent={""}
                            onChange={(content) => {
                                form.setFieldValue('content', content);
                                //setEditorContent(content);
                            }}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" className="theme-btn" htmlType="submit" style={{ height: 65, float: "right" }}>
                            {`${t("bulkEmail.send")}`} <i className="fa-solid fa-arrow-right-long" />
                        </Button>
                    </Form.Item>
                </Form>
            </Spin>
        </Modal>
    )
})